<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { SelectSearch } from '@shared/ui/fields'

import { useTutorKanbanSelectAgent } from '../../model/use-tutor-kanban-select-agent.hook'

defineOptions({
  name: 'TutorKanbanSelectAgent',
})

const {
  refOptions,
  refCurrent,
  handleChange,
} = useTutorKanbanSelectAgent()
</script>

<template>
  <RowSlot label="Agent">
    <SelectSearch
      id="tutor-kanban-agent"
      class-name="select-agent"
      placeholder="Select agent"
      :options="refOptions"
      :value="refCurrent"
      @change="handleChange"
    />
  </RowSlot>
</template>

<style scoped lang="scss" src="./TutorKanbanSelectAgent.scss" />
